import { Skeleton } from "@/components/ui/skeleton";

export const TaxFormSubmissionSkeleton = () => {
  return (
    <div className="max-w-[980px] my-5 mx-auto py-8 px-4">
      <div className="hidden lg:block">
        <Skeleton className="w-2/3 h-4" />
        <Skeleton className="w-2/3 h-4 mt-2" />
        <Skeleton className="w-1/3 h-4 mt-2" />

        <div className="flex justify-center mt-8">
          <div className="w-1/3 mx-4">
            <Skeleton className="w-full h-10" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-1/2 h-7 mt-4" />
            <Skeleton className="w-full h-10 mt-4" />
          </div>
          <div className="flex items-center mx-4">
            <Skeleton className="w-10 h-10" />
          </div>
          <div className="w-1/3 mx-4">
            <Skeleton className="w-full h-10" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-1/2 h-7 mt-4" />
            <Skeleton className="w-full h-10 mt-4" />
          </div>
          <div className="flex items-center mx-4">
            <Skeleton className="w-10 h-10" />
          </div>
          <div className="w-1/3 mx-4">
            <Skeleton className="w-full h-10" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-2/3 h-7 mt-4" />
            <Skeleton className="w-1/2 h-7 mt-4" />
            <Skeleton className="w-full h-10 mt-4" />
          </div>
        </div>
      </div>
      <div className="lg:hidden">
        <div className="max-w-[980px] my-5 py-6 px-4 mx-auto">
          <div className="mb-4">
            <Skeleton className="w-full h-5" />
            <Skeleton className="w-full h-5 mt-2" />
            <Skeleton className="w-1/3 h-5 mt-2" />
          </div>
          {[...Array(2)].map((_, index) => (
            <div key={index} className="border rounded-sm p-4 mb-4">
              <div className="flex flex-col items-center">
                <Skeleton className="w-10 h-10" />
                <Skeleton className="2/3 h-5" />
                <Skeleton className="w-full h-10 mt-4" />
                <Skeleton className="1/3 h-5 mt-4" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
